import { createGlobalStyle } from 'styled-components';
import { resetStyles } from './reset';
import { theme } from './theme';
import { gutter } from './mixins';

export const GlobalStyles = createGlobalStyle`
  ${resetStyles}

  html,
  body {
    min-height: 100vh;
  }

  html {
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    // always show the vertical scrollbar so that content doesn't jump
    overflow-y: scroll;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    box-sizing: border-box;
  }

  // inherited from <html>
  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
      margin: 0;
      font-family: 'BentonSans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      line-height: calc(22 / 14);
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      color: ${theme.colors.gray90};

      // iOS on orientation change
      text-size-adjust: 100%;
    }


  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  // placeholders
  input,
  textarea,
  select {
    &::-webkit-input-placeholder {
      color: ${theme.colors.gray80};
    }

    &::-moz-placeholder {
      opacity: 1;
      color: ${theme.colors.gray80};
    }

    &:-ms-input-placeholder {
      color: ${theme.colors.gray80};
    }
  }

  // quill editor
  .quill .ql-editor {
    b,
    strong {
      font-weight: bolder;
    }

    i,
    em {
      font-style: italic;
    }

    p {
      margin-bottom: ${gutter(6)};

      &:last-child {
        margin-bottom: 0;
      }
    }
    a {
      color: ${theme.colors.navy100};
      text-decoration: underline;
    }
  }
`;
